// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import { ProductCardSelections } from "@insite/content-library/Widgets/ProductList/ProductCardSelections";
import DataTable, { DataTablePresentationProps } from "@insite/mobius/DataTable";
import DataTableBody from "@insite/mobius/DataTable/DataTableBody";
import DataTableHead from "@insite/mobius/DataTable/DataTableHead";
import DataTableHeader from "@insite/mobius/DataTable/DataTableHeader";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { css } from "styled-components";

type Props = Omit<ProductCardSelections, "showImage">;

export interface ProductListProductsTableStyles {
    dataTableWrapper?: InjectableCss;
    dataTableStyles?: DataTablePresentationProps;
}

export const productsTableStyles: ProductListProductsTableStyles = {
    dataTableWrapper: {
        css: css`
            overflow-x: auto;
            position: relative;
            padding-top: 3px;
            width: 100%;
            display: flex;
        `,
    },
    dataTableStyles: {
        cssOverrides: {
            body: css`
                border-bottom: 1px solid ${getColor("common.border")};
            `,
        },
    },
};

const styles = productsTableStyles;

const ProductListProductsTable: FC<Props> = ({ children, ...fields }) => {
    return (
        <StyledWrapper {...styles.dataTableWrapper}>
            <DataTable {...styles.dataTableStyles}>
                <DataTableHead>
                    {fields.showPartNumbers && (
                        <DataTableHeader className="no-sticky">{translate("Product")}</DataTableHeader>
                    )}
                    {fields.showTitle && <DataTableHeader>{translate("Description")}</DataTableHeader>}
                    {fields.showAvailability && <DataTableHeader>{translate("Inventory")}</DataTableHeader>}
                    {fields.showPrice && <DataTableHeader>{translate("Price")}</DataTableHeader>}
                    <DataTableHeader></DataTableHeader>
                </DataTableHead>
                <DataTableBody>{children}</DataTableBody>
            </DataTable>
        </StyledWrapper>
    );
};

export default ProductListProductsTable;
